import { render, staticRenderFns } from "./vacaDetail.vue?vue&type=template&id=4463dc7c&scoped=true"
import script from "./vacaDetail.vue?vue&type=script&lang=js"
export * from "./vacaDetail.vue?vue&type=script&lang=js"
import style0 from "./vacaDetail.vue?vue&type=style&index=0&id=4463dc7c&prod&lang=scss&scoped=true"
import style1 from "./vacaDetail.vue?vue&type=style&index=1&id=4463dc7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4463dc7c",
  null
  
)

export default component.exports